<template>
  <v-app-bar
    :absolute="$vuetify.breakpoint.name === 'xl'"
    :fixed="$vuetify.breakpoint.name !== 'xl'"
    app
    dark
    color="#222831"
    elevation="0"
  >
    <v-container fluid class="py-0">
      <v-row
        justify="space-between"
        align="center"
        :dense="$vuetify.breakpoint.name === 'xs'"
      >
        <v-col
          cols="2"
          style="max-width:100%"
          class="d-flex align-center justify-start flex-shrink-1"
        >
          <router-link to="/">
            <v-row no-gutters justify="center" align="center">
              <v-col>
                <v-img
                  contain
                  max-height="44"
                  :max-width="$vuetify.breakpoint.name === 'xs' ? '82' : '114'"
                  :src="require('@/assets/logo-white.png')"
                />
              </v-col>
              <v-col>
                <span
                  style="font-size: 12px; color: #fff; margin: 0 5px 0 10px;"
                >
                </span>
              </v-col>
              <v-col>
                <v-img
                  contain
                  max-height="44"
                  max-width="44"
                  :src="require('@/assets/logo-soi.png')"
                />
              </v-col>
            </v-row>
          </router-link>
        </v-col>
        <v-col
          cols="1"
          style="max-width:100%"
          class="d-flex align-center justify-end flex-shrink-0"
        >
          <v-spacer />

          <v-menu
            v-if="$route.name !== 'beranda'"
            close-on-content-click
            bottom
            left
            rounded
            min-width="308"
            max-width="308"
            :nudge-width="308"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn large icon class="mr-2" v-bind="attrs" v-on="on">
                <v-icon>mdi-apps</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-container fluid>
                <v-row>
                  <v-col
                    v-for="item in menu"
                    :key="item.title"
                    class="py-0"
                    cols="4"
                  >
                    <v-hover>
                      <template v-slot:default="{ hover }">
                        <v-card
                          :to="{ name: item.url }"
                          outlined
                          class="transparent rounded-xl transition-swing"
                          :class="{ 'background-transparent-white': hover }"
                        >
                          <v-card-text class="d-flex flex-column align-center">
                            <v-img
                              max-width="24%"
                              min-width="42"
                              :src="item.icon"
                            />
                            <span class="caption mt-3">
                              {{ item.title }}
                            </span>
                          </v-card-text>
                        </v-card>
                      </template>
                    </v-hover>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-menu>
          <v-btn
            :to="isLoggedIn ? '/menu' : '/login'"
            v-else
            text
            :small="$vuetify.breakpoint.name === 'xs'"
            class="text-capitalize font-weight-bold"
          >
            Go to dashboard
          </v-btn>
          <v-menu
            v-if="isLoggedIn"
            close-on-content-click
            bottom
            left
            rounded
            min-width="200px"
            :nudge-width="200"
            offset-y
          >
            <template v-slot:activator="{ on: vMenu, attrs }">
              <v-tooltip
                :nudge-left="20"
                bottom
                left
                transition="scroll-y-transition"
              >
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn
                    icon
                    :large="$vuetify.breakpoint.name === 'xs'"
                    v-bind="attrs"
                    v-on="{ ...tooltip, ...vMenu }"
                  >
                    <v-avatar
                      color="light-green"
                      :size="$vuetify.breakpoint.name === 'xs' ? 32 : 38"
                    >
                      <v-img
                        :src="user.accountAvatar"
                        :alt="user.accountName"
                      />
                    </v-avatar>
                  </v-btn>
                </template>
                <span> {{ user.accountName }} </span>
              </v-tooltip>
            </template>
            <v-card>
              <v-list>
                <v-list-item>
                  <v-list-item-avatar color="light-green">
                    <v-img :src="user.accountAvatar" :alt="user.accountName" />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ user.accountName }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      Administator
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-divider />
              <v-list :disabled="loadingLogout" flat dense class="py-0">
                <v-list-item-group color="primary">
                  <v-list-item
                    color="light-green"
                    exact
                    :to="{ name: 'account-profile' }"
                  >
                    <v-list-item-icon>
                      <v-icon>mdi-account-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Profil Saya</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    color="light-green"
                    exact
                    :to="{ name: 'account-password' }"
                  >
                    <v-list-item-icon>
                      <v-icon>mdi-lock-alert-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Ganti Password</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
              <v-divider />
              <v-list :disabled="loadingLogout" flat dense class="py-0">
                <v-list-item-group color="primary">
                  <v-list-item color="light-green" @click="logout">
                    <v-list-item-icon>
                      <v-icon>mdi-logout</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Keluar</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-menu>
          <!-- <v-btn
            to="/login"
            v-else
            text
            :small="$vuetify.breakpoint.name === 'xs'"
            class="text-capitalize font-weight-bold"
          >
            Sign In
          </v-btn> -->
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import menu from '@/mixins/menu';
export default {
  name: 'Navbar',
  mixins: [menu],
  data() {
    return {
      loadingLogout: false
    };
  },
  computed: { ...mapState(['user']), ...mapGetters(['isLoggedIn']) },
  methods: {
    async logout() {
      this.loadingLogout = true;
      try {
        await this.$store.dispatch('logout');
        this.$router.push('/login');
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      } finally {
        this.loadingLogout = false;
      }
    }
  }
};
</script>
